import { atom, atomFamily } from "recoil";
import { recoilPersist } from "recoil-persist";
import { PaginationPayload, SortPayload } from "react-admin";
import type { Schema } from "@pdfme/common";

const { persistAtom } = recoilPersist();

export interface AutovioContext {
  drivingSchoolId?: string;
}

export const persistentAutovioContext = atom<AutovioContext>({
  key: "autovioContext",
  default: {},
  effects: [persistAtom],
});

export const persistentPaginationStateFamily = atomFamily<Omit<PaginationPayload, "page">, string>({
  key: "paginationState",
  default: { perPage: 25 },
  effects: [persistAtom],
});

export const persistentSortStateFamily = atomFamily<SortPayload | undefined, string>({
  key: "sortState",
  default: undefined,
  effects: [persistAtom],
});

export const persistentPdfMeTemplateSchemas = atomFamily<Schema[][] | undefined, string /* the AutoForm id */>({
  key: "persistentPdfMeTemplateSchemas",
  default: undefined,
  effects: [persistAtom],
});

export const persistentCalendarViewStateFamily = atomFamily<string | undefined, string>({
  key: "calendarViewState",
  default: undefined,
  effects: [persistAtom],
});

export interface DrivingSchoolCoursesCalendarFiltersState {
  selectedBranchId?: string;
  selectedCourseType?: string;
  selectedTheoryCourseType?: string;
}

export const persistentDrivingSchoolCoursesCalendarFiltersStateFamily = atomFamily<
  DrivingSchoolCoursesCalendarFiltersState,
  string
>({
  key: "drivingSchoolCoursesCalendarFiltersState",
  default: {},
  effects: [persistAtom],
});
